module.exports = __webpack_public_path__ + "img/ranger.8209da8a.png";